import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db3511b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自分配起", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "天有效", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最晚分配时间", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_enterprise_input = _resolveComponent("app-enterprise-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_DetailForm = _resolveComponent("DetailForm")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.visible) = $event)),
    width: "800px",
    title: "折扣卡",
    onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleCancel('modal')))
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取 消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.showDetail)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: "last",
            type: "primary",
            onClick: _ctx.lastStep
          }, {
            default: _withCtx(() => [
              _createTextVNode("上一步")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_a_button, {
            key: "next",
            type: "primary",
            onClick: _ctx.nextStep
          }, {
            default: _withCtx(() => [
              _createTextVNode("下一步")
            ]),
            _: 1
          }, 8, ["onClick"])),
      (_ctx.showDetail)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: "submit",
            type: "primary",
            loading: _ctx.loading,
            onClick: _ctx.handleOk
          }, {
            default: _withCtx(() => [
              _createTextVNode("确 定")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.cardModel,
        rules: _ctx.rules,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "所属企业",
            name: "enterpriseId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_app_enterprise_input, {
                value: _ctx.cardModel.enterpriseId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cardModel.enterpriseId) = $event)),
                style: {"width":"180px"},
                "disable-in-open": "",
                "onUpdate:object": _ctx.changeEnterprise
              }, null, 8, ["value", "onUpdate:object"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "活动名称",
            name: "activityName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.cardModel.activityName,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cardModel.activityName) = $event)),
                maxlength: 25,
                placeholder: "请输入活动名称"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "折扣类型",
            name: "discountType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.cardModel.discountType,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cardModel.discountType) = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "FULL_REDUCE" }, {
                    default: _withCtx(() => [
                      _createTextVNode("满减")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "面额",
            name: "fullAmount"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, { align: "baseline" }, {
                default: _withCtx(() => [
                  _createTextVNode(" 满 "),
                  _createVNode(_component_a_input_number, {
                    value: _ctx.cardModel.fullAmount,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cardModel.fullAmount) = $event)),
                    min: 0.1,
                    max: 1000,
                    precision: 2
                  }, null, 8, ["value"]),
                  _createTextVNode(" 减 "),
                  _createVNode(_component_a_input_number, {
                    value: _ctx.cardModel.reduceAmount,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cardModel.reduceAmount) = $event)),
                    min: 0.1,
                    max: 1000,
                    precision: 2
                  }, null, 8, ["value"]),
                  _createTextVNode(" 元 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "使用渠道",
            name: "useChannel"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_checkbox_group, {
                value: _ctx.cardModel.useChannel,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cardModel.useChannel) = $event)),
                class: "fl_cl"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_a_checkbox, { value: "REFUEL" }, {
                    default: _withCtx(() => [
                      _createTextVNode("加油")
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.allChannels.includes('REFUEL')]
                  ]),
                  (_ctx.cardModel.enterpriseId && _ctx.cardModel.useChannel.includes('REFUEL'))
                    ? (_openBlock(), _createBlock(_component_a_form_item, {
                        key: 0,
                        name: "useChannelDetail",
                        class: "checkbox_form_item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox_group, {
                            value: _ctx.cardModel.useChannelDetail,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cardModel.useChannelDetail) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelObj, (label, key) => {
                                return (_openBlock(), _createBlock(_component_a_checkbox, {
                                  key: key,
                                  value: key,
                                  name: "oil"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _withDirectives(_createVNode(_component_a_checkbox, { value: "ELECTRICITY" }, {
                    default: _withCtx(() => [
                      _createTextVNode("充电")
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.allChannels.includes('ELECTRICITY')]
                  ]),
                  _withDirectives(_createVNode(_component_a_checkbox, { value: "CARMAINTENANCE" }, {
                    default: _withCtx(() => [
                      _createTextVNode("养车")
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, _ctx.allChannels.includes('CARMAINTENANCE')]
                  ])
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "数量",
            name: "quantity"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_number, {
                value: _ctx.cardModel.quantity,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cardModel.quantity) = $event)),
                min: 1,
                max: 100000,
                precision: 0,
                style: {"width":"35%"}
              }, null, 8, ["value"]),
              _createTextVNode(" 张 ")
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "有效期",
            name: "fixedTermFlag"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.cardModel.fixedTermFlag,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.cardModel.fixedTermFlag) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("固定")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("非固定")
                    ]),
                    _: 1
                  }),
                  (_ctx.cardModel.fixedTermFlag === 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_a_form_item, {
                          name: "effectiveStartDate",
                          style: {"margin-top":"15px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_space, { align: "baseline" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 生效时间 "),
                                _createVNode(_component_a_date_picker, {
                                  value: _ctx.cardModel.effectiveStartDate,
                                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cardModel.effectiveStartDate) = $event)),
                                  type: "date",
                                  "value-format": "YYYY-MM-DD 00:00:00",
                                  placeholder: "请选择",
                                  style: {"width":"100%"}
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, { name: "effectiveEndDate" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_space, { align: "baseline" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 失效时间 "),
                                _createVNode(_component_a_date_picker, {
                                  value: _ctx.cardModel.effectiveEndDate,
                                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.cardModel.effectiveEndDate) = $event)),
                                  type: "date",
                                  "value-format": "YYYY-MM-DD 23:59:59",
                                  placeholder: "请选择",
                                  style: {"width":"100%"}
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 64))
                    : (_ctx.cardModel.fixedTermFlag === 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_a_form_item, {
                            name: "effectiveDays",
                            style: {"margin-top":"15px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_space, { align: "baseline" }, {
                                default: _withCtx(() => [
                                  _hoisted_1,
                                  _createVNode(_component_a_input_number, {
                                    value: _ctx.cardModel.effectiveDays,
                                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cardModel.effectiveDays) = $event)),
                                    min: 1,
                                    precision: 0
                                  }, null, 8, ["value"]),
                                  _hoisted_2
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, { name: "lastedEffectiveDate" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_space, { align: "baseline" }, {
                                default: _withCtx(() => [
                                  _hoisted_3,
                                  _createVNode(_component_a_date_picker, {
                                    value: _ctx.cardModel.lastedEffectiveDate,
                                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.cardModel.lastedEffectiveDate) = $event)),
                                    type: "date",
                                    "value-format": "YYYY-MM-DD 23:59:59",
                                    placeholder: "请选择",
                                    style: {"width":"100%"}
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ], 64))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "label-col", "wrapper-col"]), [
        [_vShow, !_ctx.showDetail]
      ]),
      _withDirectives(_createVNode(_component_DetailForm, { "detail-info": _ctx.detailInfo }, null, 8, ["detail-info"]), [
        [_vShow, _ctx.showDetail]
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}